import { useContext } from 'react'
import { ActivitySummaryContext } from '../context'

export function useActivitySummaryContext() {
  const value = useContext(ActivitySummaryContext)

  if (value === undefined) throw Error('use it properly')

  return value
}
